import { CardsGridSimpleProps } from 'libs/contentful/props';
import { cn, getColorway } from 'utils/styles';
import CardsStackedItemCopyVariant from 'components/CardsStacked/CardsStackedItemCopyVariant';
import { liveUpdateAttrs } from 'libs/contentful/utils';

const CardsGridSimple = ({ sys, color, cards }: CardsGridSimpleProps) => {
  if (!cards || !cards.items.length) return null;

  return (
    <section className={cn(getColorway(color))} data-testid="cardsGridSimple">
      <div className="content-wrapper">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 py-12 md:py-20" {...liveUpdateAttrs(sys?.id, 'cards')}>
          {cards.items.map(card => (
            <CardsStackedItemCopyVariant
              key={card.sys?.id}
              {...card}
              shortDescription={card.copy}
              desktopMedia={card.icon}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CardsGridSimple;
